// extracted by mini-css-extract-plugin
export var image = "PageEventPost-module--image--7yeRm";
export var imageWrapper = "PageEventPost-module--imageWrapper--T5P1D";
export var label = "PageEventPost-module--label--KcEIw";
export var preamble = "PageEventPost-module--preamble--45VUd";
export var title = "PageEventPost-module--title--s0ycw";
export var wrapper = "PageEventPost-module--wrapper--LTlY-";